import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
	type TimelineResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { isIdentificationDocumentItem } from "web_myplann/NotificationCenter/Utils/isIdentificationDocumentItem";

export interface TimelineRightsFilter {
	hasRemindersRight: boolean;
	hasDocumentsFeature: boolean;
	documentsOnly?: boolean;
}

type ItemPredicate = (item: TimelineItemResponseDTO) => boolean;

const isReminderItem: ItemPredicate = (item) =>
	item.category === TimelineItemCategoryEnum.Reminder ||
	(item.category === TimelineItemCategoryEnum.Notification &&
		item.subcategory === TimelineItemSubcategoryEnum.ReminderTerm);

export const filterTimelineItemsByRights = (
	response: TimelineResponseDTO,
	{
		hasRemindersRight,
		hasDocumentsFeature,
		documentsOnly,
	}: TimelineRightsFilter,
): TimelineResponseDTO => {
	const excluded: ItemPredicate[] = [];
	if (!hasRemindersRight) {
		excluded.push(isReminderItem);
	}
	if (!hasDocumentsFeature) {
		excluded.push(isIdentificationDocumentItem);
	}
	if (excluded.length === 0 && !documentsOnly) {
		return response;
	}
	return {
		...response,
		items: response.items.filter(
			(item) =>
				!excluded.some((isExcluded) => isExcluded(item)) &&
				(!documentsOnly || isIdentificationDocumentItem(item)),
		),
	};
};
